/* eslint-disable */
const protobufPackageSarasa = "decentraland.sdk.components.common";
/**
 * @public
 */
export var CameraType;
(function (CameraType) {
    CameraType[CameraType["CT_FIRST_PERSON"] = 0] = "CT_FIRST_PERSON";
    CameraType[CameraType["CT_THIRD_PERSON"] = 1] = "CT_THIRD_PERSON";
    /** CT_CINEMATIC - controlled by the scene */
    CameraType[CameraType["CT_CINEMATIC"] = 2] = "CT_CINEMATIC";
})(CameraType || (CameraType = {}));
